import React from "react";

function SingleService(service) {
  return (
    <div className="service__mobile-card">
      <img src={service.img} alt={service.title} />
      <p className="service__title__mobile">{service.title}</p>
    </div>
  );
}

export default SingleService;
